import axios from 'axios';
import { userService } from '@/pages/Users/service';
import store from '@/store';
import vm from '../main';
import { getUserAction } from '../shared/helpers';

export const apiBaseUrl = process.env.VUE_APP_API_URL;

const ajax = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

ajax.CancelToken = axios.CancelToken;
ajax.isCancel = axios.isCancel;

/*
 * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
 */
ajax.interceptors.request.use(
  config => {
    store.commit('global/setPendingRequest');

    let user = JSON.parse(sessionStorage.getItem('user'));

    if (user) {
      config.headers['Authorization'] = `Bearer ${user.token}`;
    }

    return config;
  },

  error => Promise.reject(error)
);

ajax.interceptors.response.use(
  response => {
    store.commit('global/setCompleteRequest');
    return response;
  },
  error => {
    store.commit('global/setCompleteRequest');

    if (((error || {}).response || {}).status == 401) {
      userService.logOut();
    }

    return Promise.reject(error);
  }
);

const request = async ({ url, method, name = '', ...rest }) => {
  try {
    return await ajax({
      method,
      url,
      ...rest
    });
  } catch (error) {
    const action = getUserAction(method);

    // Show error notification
    vm.$snotify.error(`There was a problem with ${action} ${name}`);

    throw error;
  }
};

export default {
  get: async (url, { ...rest }) =>
    await request({ method: 'get', url, ...rest }),
  post: async (url, { body, ...rest }) =>
    await request({ method: 'post', url, data: body, ...rest }),
  put: async (url, { body, ...rest }) =>
    await request({ method: 'put', url, data: body, ...rest }),
  patch: async (url, { body, ...rest }) =>
    await request({ method: 'patch', url, data: body, ...rest }),
  delete: async (url, { ...rest }) =>
    await request({ method: 'delete', url, ...rest })
};

//get api response data
export function getApiResponseData(apiResponse) {

  if (apiResponse) {

    const apiResponseDataSet = apiResponse.data;

    const {
      data,
      success,
      hasException,
      message,
      invalidModelState
    } = apiResponseDataSet;

    if (!hasException && success) {
      return data;
    }

    else if (hasException) {
      vm.$snotify.error(`Something went wrong try after some time.`);
    }

    else if (invalidModelState) {
      vm.$snotify.error(`In valid data posted.`);
    }

  }

  return {};
}